<template>
  <v-menu v-model="userMenu" left :offset-y="true" transition="slide-y-transition"> <!-- fade-up -->
    <template v-slot:activator="{}">
        <v-btn color="text" icon class="dots-btn e-link pa-0 d-flex align-center" @click.stop="userMenu = !userMenu">
            <!-- <div class="e-link d-flex justify-center align-center">
                <v-icon style="width: 17px">mdi-menu-down</v-icon>
            </div> -->
            <avatar v-if="pcOnly" color="grey darken-2" :size="35" :icon-size="35" :src="avatar"/>
            <v-icon v-else size="24">mdi-dots-vertical</v-icon>
        </v-btn>
    </template>
    <v-list min-width="180" >
        <!-- <v-list-item>
            <div>
                أهلا <span class="primary--text text--darken-2">{{name.split(' ')[0]}}</span>
            </div>
        </v-list-item> -->
        <v-list-item @click="$router.push({name: 'profile'}); userMenu = false">
            <v-list-item-icon class="me-3 my-auto">
                <v-icon color="strong-text">mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-title>الملف الشخصي</v-list-item-title>
        </v-list-item>
        <v-list-item @click="$router.push({name: 'help'}); userMenu = false">
            <v-list-item-icon class="me-3 my-auto">
                <v-icon color="strong-text">mdi-help</v-icon>
            </v-list-item-icon>
            <v-list-item-title>الدعم الفني</v-list-item-title>
        </v-list-item>
        <v-list-item link @click="logoutDialog = true; userMenu = false">
            <v-list-item-icon class="me-3 my-auto">
                <v-icon color="error darken-1">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>تسجيل الخروج</v-list-item-title>
        </v-list-item>
    </v-list>

    <logout-dialog v-model="logoutDialog" />
</v-menu>
</template>

<script>
import Avatar from '../../default/avatar'
import LogoutDialog from '../../default/dialogs/logout'

export default {
    props: ['name', 'avatar'],
    data(){
        return {
            userMenu: false,
            logoutDialog: false,
        }
    },
    components: {Avatar, LogoutDialog},
    computed: {
        pcOnly(){
            return this.$vuetify.breakpoint.mdAndUp;
        },
    }
}
</script>

<style>

</style>